import { createRoot } from 'react-dom/client';
import 'normalize.css';
import 'assets/styles/index.scss';
import './i18n';
import App from 'components/App';
import { SimulationProvider } from 'components/pages/Exploitation/SimulationContext';
import { Amplify } from 'aws-amplify';
import { ExploitationProvider } from 'utils/context';

Amplify.configure({
  API: {
    GraphQL: {
      endpoint: process.env.REACT_APP_APPSYNC_ENDPOINT,
      region: 'eu-west-3',
      defaultAuthMode: 'apiKey',
      apiKey: process.env.REACT_APP_APPSYNC_APIKEY,
    },
  },
});

createRoot(document.getElementById('root')).render(
  <ExploitationProvider>
    <SimulationProvider>
      <App />
    </SimulationProvider>
  </ExploitationProvider>,
);
